module.exports = __webpack_public_path__ + "static/media/call.b16b7f77.svg";